module.exports = __webpack_public_path__ + "img/shape_yellow.229bfb43.png";